var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 100,
    viewBox: "0 0 181 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0.792488 145.954V110.914L9.91249 110.434C20.4725 110.434 27.9925 107.874 32.4725 102.754C36.6325 97.6342 38.7125 90.7542 38.7125 82.1142V65.3142H7.9925V0.514194H75.6725V84.9942C75.6725 107.714 70.5525 123.394 60.3125 132.034C49.7525 140.994 35.8325 145.634 18.5525 145.954H0.792488ZM105.432 145.954V110.914L115.032 110.434C125.272 110.434 132.632 107.874 137.112 102.754C141.272 97.6342 143.352 90.7542 143.352 82.1142V65.3142H112.632V0.514194H180.312V84.9942C180.312 107.714 175.192 123.394 164.952 132.034C154.712 140.994 140.792 145.634 123.192 145.954H105.432Z",
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom);
export default __webpack_public_path__ + "static/media/bottom.53c2486a24435fb8ed6141c9822d8701.svg";
export { ForwardRef as ReactComponent };